import { defineComponent } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import { NMessageProvider } from 'naive-ui'
import { useHead } from '@unhead/vue'
import BottomFloatingBar from '@/components/bottom-floating-bar'
import { useSiteConfigStore } from '@/stores/site-config-store'

const App = defineComponent({
  setup() {
    const siteConfigStore = useSiteConfigStore()
    const route = useRoute()
    // 高手之家（/gszj*）为全屏页，49208 上该页无底部「下载APP」浮条，且浮条会压住发帖按钮/悬浮按钮
    const showFloatingBar = () => !route.path.startsWith('/gszj')
    // 全局兜底标题：未单独配置 SEO 的页面用站点名；各页面 useSeo() 设置的标题会覆盖它
    useHead({
      title: () => siteConfigStore.siteName || '彩票助手',
    })

    return () => (
      <NMessageProvider>
        <div class="w-full">
          <RouterView />
          {showFloatingBar() && <BottomFloatingBar />}
        </div>
      </NMessageProvider>
    )
  },
})

export default App
